export default {
  "HitPaw Add Music to Audio Online": "HitPaw Online Aggiunge Musica all'Audio",
  "Add BGM to Audio without any difficulties.": "Aggiunge BGM all'Audio senza difficoltà.",
  "Add New": "Aggiunge un nuovo",
  "Format": "Formato",
  "Add tracks": "Aggiungere tracce",

};
